import { render, staticRenderFns } from "./approverSettings.vue?vue&type=template&id=ee6cf428&"
import script from "./approverSettings.vue?vue&type=script&lang=js&"
export * from "./approverSettings.vue?vue&type=script&lang=js&"
import style0 from "./approverSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports